// EVENTS.COMPONENTS.APPLICATION.REWARDS.EARN.ACHIEVEMENT_CARD

import { CLAIM_POINTS_MODAL } from './claimPointsModal';

export const ACHIEVEMENT_CARD = {
  CLAIM_POINTS_MODAL,
  OPEN_MORE_INFO_MODAL: 'achievement_info-opened_modal',
  OPEN_REDEEM_MODAL: 'achievement_redeem-opened_modal'
};
